export default __webpack_public_path__ + "static/media/searchcar.6d5c6030.png";